<template>
  <tr
      :id="timeSheetDay.date" :key="index"
      :class="{selected: isSelected(timeSheetDay.date)}"
      @click="toggle(timeSheetDay.date)">
    <td>{{ formatDateFromString(timeSheetDay.date) }}</td>

    <template>
      <td :style="{ color: getColor(newSDWorxCode) }">
        <template v-if="isUpdateMode">
          <TextInputField v-model="newSDWorxCode" />
          <div v-if="!isCodeValid" style="color: red;">Invalid code format!</div>
        </template>
        <template v-else>
          {{ timeSheetDay.code}}
        </template>
      </td>
    </template>

    <td>{{ timeSheetDay.hoursWorked | convertDotToCommaInNumber }}</td>
    <td>{{ timeSheetDay.codeDefinition }}</td>
    <td>
      <button v-show="timeSheetDay.code === '0010'"
        class="btn-basic invisible" disabled>
        /
      </button>
      <button
          v-show="this.timeSheetDay.absenceId && (timeSheetDay.code === 'T900' || timeSheetDay.code === 'T903')"
          :disabled="isConverting || (timeSheetDay.code === 'T900' && userAbsenceCounters[0].currentBalance < 1)"
          class="btn-basic btn-gold" @click="convertToSickLeaveWithoutCertificate()">
        Omzetten
      </button>
      <button
          v-show="!isUpdateMode && this.timeSheetDay.absenceId && timeSheetDay.code !== 'T900' && timeSheetDay.code !== 'T903' && timeSheetDay.code !== '1025'"
          class="btn-basic btn-gold" @click="toggleUpdateMode">
        Aanpassen
      </button>
      <button
          :disabled="!isCodeValid || noChangeOfCode" v-show="isUpdateMode"
          class="btn-basic btn-fill-pulse mr-2" @click="save">
        Opslaan
      </button>
      <button
          :disabled="isSaving" v-show="isUpdateMode"
          class="btn-basic btn-fill-pulse-dark" @click="toggleUpdateMode">
        Annuleren
      </button>
    </td>
  </tr>
</template>

<script>

import {mapActions, mapGetters, mapMutations} from "vuex";
import codes from "@/constants/Codes";
import moment from "moment";
import {toYear} from "@/util/DateUtil";
import TextInputField from "@/components/inputFields/TextInputField.vue";

export default {
  name: "AdminTimeSheetTableRowComponent",
  components: {TextInputField},
  props: ['timeSheetDay', 'index'],
  data: () => ({
    isUpdateMode: false,
    isSaving: false,
    isCodeValid: true,
    newSDWorxCode: "",
    vacationCounterAvailable: true,
    isConverting: false,
    validPattern: /^[A-Z0-9]{4}$/,
  }),
  computed: {
    ...mapGetters({
      selectedUserDetail: "administrationUser/selectedUserDetail",
      timeSheetDays: 'administrationTimeSheet/timeSheetDays',
      selectedTimeSheetInfo: 'administrationTimeSheet/selectedTimeSheetInfo',
      vacationTypes: "administrationUser/vacationTypes",
      userAbsenceCounters: 'administrationUser/userAbsenceCounters',
      currentlySelectedMonth: "time/currentlySelectedMonth"
    }),
    noChangeOfCode() {
      return this.newSDWorxCode === this.timeSheetDay.code;
    }
  },
  watch: {
    newSDWorxCode(newValue) {
      this.isCodeValid = this.validateCode(newValue);
    }
  },
  created() {
    this.checkIfVacationCountersAreAvailable();
    this.newSDWorxCode = this.timeSheetDay.code;
  },
  methods: {
    ...mapActions("administrationTimeSheet", ["updateAbsenceCountersBySDWorxCode", "fetchTimeSheetDays","downloadAdminTimeSheet", "reopenTimeSheet", "unlockTimeSheet", "isLocked", "updateAbsence"]),
    ...mapActions("administrationUser", ["fetchDetailsForSelectedUser", "fetchUsers", "fetchVacationForSelectedUserAndCurrentYear", "fetchAbsenceCountersForUser"]),
    ...mapMutations({
      setSelectedUser: "administrationUser/setSelectedUser",
      setSelectedTimesheetInfo: "administrationTimeSheet/setSelectedCustomerTimesheetInfo",
      setSelectedCustomerTimesheetInfo: "administrationTimeSheet/setSelectedCustomerTimesheetInfo",
      setCurrentlySelectedContractId: "administrationTimeSheet/setCurrentlySelectedContractId",
      setCurrentlySelectedUserId: "administrationTimeSheet/setCurrentlySelectedUserId",
      setCurrentlySelectedContractIndex: "administrationTimeSheet/setCurrentlySelectedContractIndex"
    }),
    isSelected: function (props) {
      return this.selectedShift === props;
    },
    getColor: function (code) {
      return codes[code] || 'black';
    },
    toggleUpdateMode() {
      this.isUpdateMode = !this.isUpdateMode;
      this.newSDWorxCode = this.timeSheetDay.code;
    },
    checkIfVacationCountersAreAvailable() {
      this.vacationCounterAvailable = false;
      this.vacationTypes.forEach(vacationType => {
        if (vacationType.currentBalance > 0) {
          this.vacationCounterAvailable = true;
        }
      });
    },
    convertToSickLeaveWithoutCertificate() {
      this.isConverting = true;
      const fullDay = this.timeSheetDay.hoursWorked === 7.6;
      const absenceCategory = (this.timeSheetDay.code) === 'T900' ?
          'SICK_LEAVE_NO_CERTIFICATE' : 'SICK_LEAVE';

      const updateAbsenceDto = {
        id: this.timeSheetDay.absenceId,
        absenceCategory,
        fullDay,
        editedByAdmin: true
      };

     this.updateAbsence(updateAbsenceDto)
         .then(() => {
           this.fetchTimeSheetDays();
           this.fetchAbsenceCountersForUser(toYear(this.currentlySelectedMonth));
           this.isConverting = false;
         })
         .catch(() => this.isConverting = false);
     },
    save() {
      this.isSaving = true;
      const year = this.timeSheetDay.date.substring(0, 4);
      const absenceId = this.timeSheetDay.absenceId;
      const userId = this.selectedUserDetail.id;
      const originalSDWorxCode = this.timeSheetDay.code || undefined;
      const newSDWorxCode = this.newSDWorxCode || undefined;
      const index = this.index;
      const updateCounterDto = {
        absenceId,
        userId,
        originalSDWorxCode,
        newSDWorxCode
      };
      const payload = {
        updateCounterDto,
        year,
        index
      };
      this.updateAbsenceCountersBySDWorxCode(payload)
          .then(() => {
            this.isSaving = false;
            this.isUpdateMode = false;
            this.fetchTimeSheetDays();
            this.fetchVacationForSelectedUserAndCurrentYear();
            this.checkIfVacationCountersAreAvailable();
          }).catch(() => {
        this.newSDWorxCode = originalSDWorxCode;
        this.isSaving = false;
        this.isUpdateMode = false;
      });
    this.isSaving = false;
    this.isUpdateMode = false;
    },
    toggle: function (props, withJump) {
      if (!props) return null;
      if (this.selectedShift === props) this.selectedShift = "";
      else {
        if (withJump) {
          document.getElementById(props).scrollIntoView(true);
        }
        this.selectedShift = props;
      }
    },
    formatDateFromString: function (date) {
      if (date) {
        return moment(date).locale('nl').format('DD-MM-YYYY');
      }
    },
    validateCode() {
      return this.validPattern.test(this.newSDWorxCode);
    }
  }
};
</script>

<style scoped>

td {
  vertical-align: middle;
}
</style>